export const TOGGLE_SIDER_COLLAPSED = `TOGGLE_SIDER_COLLAPSED`;
